import React from 'react'
import BigDataVideo from '../assets/traffic_moving.mp4'

const FooterVideo = () => {
  return (
    <div>
        {/* BIG DATA VIDEO */}
      <div className="relative w-full overflow-hidden my-20" style={{ height: '25rem' }}>
        {/* Video Background with Blue Tint */}
        <div className="relative h-full w-full">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover blur-sm"
            style={{ filter: 'brightness(0.7) sepia(0.3) hue-rotate(180deg) saturate(1.5) blur(2px)' }}
          >
            <source src={BigDataVideo} type="video/mp4" />
          </video>

          {/* White overlay for cleaner look */}
          <div className="absolute inset-0 bg-white opacity-10"></div>
        </div>

        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-6">
  <div className="max-w-3xl space-y-4">
    <h1 className="text-3xl md:text-4xl font-bold text-white leading-tight">
      Data Doesn't Wait.
      <br />
      <span className="text-white font-extrabold">Lead with Intelligence.</span>
    </h1>

    <p className="text-lg md:text-xl text-white opacity-90">
      We help enterprises and ambitious teams harness their
      <br />
      power with <span className="font-semibold">Data Strategy</span>,
      <span className="font-semibold"> Analytics</span>, and
      <span className="font-semibold"> AI Solutions</span>.
    </p>
  </div>
</div>

      </div>
    </div>
  )
}

export default FooterVideo